<template>
    <div v-if="!loadingPage" class="pb-3">
        <b-card class="mb-2">
            <div class="d-flex align-items-center">
                <div @click="$router.push('/products')" class="border-right pr-1 pointer">
                    <div class="text-center mb-50">
                        <feather-icon icon="ArrowRightIcon" size="26" />
                    </div>
                    <div style="font-size: 13px;">بازگشت</div>
                </div>
                <div class="px-1">
                    <h5 class="d-flex align-items-center font-weight-bolder mb-50">
                        <span>
                            ویرایش گروهی محصولات
                        </span>
                    </h5>
                    <h5 class="mb-0">نوع: {{ type.name }}</h5>
                </div>
            </div>
        </b-card>
        <b-row>
            <b-col md="6">
                <div>
                    <b-card no-body class="mb-1">
                        <v-select v-model="type" :clearable="false" :searchable="false" dir="rtl" :options="optionsType"
                            label="name">
                        </v-select>
                    </b-card>
                </div>
            </b-col>
            <b-col md="3">
                <b-button @click="reset" :disabled="loading" class="w-100 mb-1" variant="info">
                    تنظیم مجدد
                </b-button>
            </b-col>
            <b-col md="3">
                <b-button @click="productBatch" :disabled="loading" class="w-100 mb-1" variant="primary">
                    ذخیره تغییرات
                </b-button>
            </b-col>
        </b-row>
        <div v-if="!loading">
            <b-card v-for="(item, index) in productsData" :key="index" class="p-1 mb-1" no-body>
                <b-row>
                    <b-col md="6" class="d-flex align-items-center justify-content-center mb-1 mb-md-0">
                        <h5 class="mb-0 text-center">
                            {{ item.name_Fa }}
                        </h5>
                    </b-col>
                    <b-col md="3" class="d-flex align-items-center justify-content-center mb-1 mb-md-0">
                        <div class="w-100">
                            <cleave dir="ltr" v-model="item.basePrice" class="form-control text-center"
                                autocomplete="off" :raw="false" :options="amountSeparator" />
                        </div>
                    </b-col>
                    <b-col md="3" class="d-flex align-items-center justify-content-center">
                        <div class="w-100">
                            <cleave dir="ltr" v-model="item.discountPercent" class="form-control text-center"
                                autocomplete="off" :raw="false" :options="amountSeparator" />
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>

<script>
import Cleave from 'vue-cleave-component'
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        Cleave,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        vSelect
    },
    data() {
        return {
            amountSeparator: {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
            },
            loadingPage: true,
            loading: false,
            optionsType: [
                { name: 'مبلغ و تخفیف محصولات', id: 1 },
            ],
            type: { name: 'مبلغ و تخفیف محصولات', id: 1 },
            productsData: [],
            productsDataMain: [],
        }
    },
    methods: {
        reset() {
            this.loading = true;
            this.productsData = []
            this.productsData = JSON.parse(JSON.stringify(this.productsDataMain));
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        getProduct() {
            this.loading = true;
            storeService.getProductAll(this.storeId).then(({ data }) => {
                this.productsData = JSON.parse(JSON.stringify(data.items));
                this.productsDataMain = JSON.parse(JSON.stringify(data.items));
                this.loading = false
                this.loadingPage = false
            })
        },
        productBatch() {
            this.loading = true;
            let products = []
            this.productsData.forEach(item => {
                products.push({
                    id: item.id,
                    discountPercent: Number(item.discountPercent.replace(/,/g, '')),
                    basePrice: Number(item.basePrice.replace(/,/g, '')),
                    isAvailable: item.isAvailable,
                    isSpecial: item.isSpecial,
                    isActive: item.isActive,
                })
            });
            storeService.productBatch(this.storeId, { products: products }).then(({ data }) => {
                this.$router.push('/products')
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getProduct()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>